<template>
  <div>
    <pc-header></pc-header>
    <div class="header-wrap">
      <img src="../../../assets/images/news/news-head-bg.png" />
    </div>

    <div class="content-wrap">
      <div class="title">支付宝、微信、云闪付互联互通新进展</div>
      <div class="time">
        时间：&nbsp;&nbsp;2021-02-24 09:27 2021-12-03 17:02
      </div>
      <div class="rich_media_content " id="js_content" style="visibility: visible;">

        <article data-id="2755" data-use="1" data-author="Wxeditor" style="margin: 5px auto;max-width: 100%;font-size: 14px;box-sizing: border-box !important;overflow-wrap: break-word !important;">
          <section style="max-width: 100%;line-height: 25px;text-align: center;box-sizing: border-box !important;overflow-wrap: break-word !important;">
            <section style="margin-bottom: -10px;padding-right: 20px;padding-left: 20px;box-sizing: border-box;max-width: 100%;display: inline-block;border-bottom: 1px solid rgb(127, 127, 127);overflow-wrap: break-word !important;">
              <section style="margin-bottom: -5px;padding-right: 10px;padding-bottom: 5px;padding-left: 10px;box-sizing: border-box;max-width: 100%;border-bottom: 1px solid rgb(127, 127, 127);font-size: 15px;overflow-wrap: break-word !important;">
                <p style="white-space: normal;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;">
                  <strong>支付宝-银联</strong>
                </p>
              </section>
            </section>
            <section style="margin-right: auto;margin-left: auto;box-sizing: border-box;max-width: 100%;width: 11px;height: 11px;border-right: 1px solid rgb(127, 127, 127);border-bottom: 1px solid rgb(127, 127, 127);transform: rotate(45deg);overflow-wrap: break-word !important;"><br></section>
          </section>
        </article>
        <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
          <span style="font-size: 15px;">日前支付宝发布消息称，支付宝与中国银联在全国范围实现收款码扫码互认，同时已经与28家银行机构也实现线下扫码互认。</span>
        </p>
        <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;"><br></p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;">
          <span style="font-size: 15px;">根据支付宝的消息显示，支付宝与中国银联在2020年开始基于条码互联互通业务展开密切沟通和探索，并陆续在北京、天津、广州、深圳、成都、重庆、西安等多个城市实现收款码扫码互认。目前，支付宝与中国银联在全国范围实现收款码扫码互认。</span>
        </p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;"><br></p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;">
          <span style="font-size: 15px;">同时，支付宝与中国银联推动完成了工行、建行、中行、交行、招行、中信、广发银行、Mi Pay等28家银行和机构的开放合作，用户可以通过各银行、云闪付及其他机构的APP扫描支付宝收款码实现支付。</span>
        </p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;"><br></p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;">
          <span style="font-size: 15px;">据悉，这是支付宝近期第二次公布与中国银联互联互通的工作进展。此前在10月初，支付宝对外透露，已逐步向银联云闪付开放线上支付场景，第一步开放的交易场景是淘宝平台，淘宝商铺已经支持消费者通过云闪付付款。在刚刚过去的“天猫双11”，中国银联云闪付也首次参与其中。</span>
        </p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;"><br></p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;">
          <span style="font-size: 15px;">支付宝方面表示，未来将与中国银联等合作伙伴紧密合作，围绕用户体验持续探索开放更多场景，切实推进支付领域的互联互通，助力建设开放共享的数字生态。</span>
        </p>
        <p style="margin-right: 16px;margin-left: 16px;line-height: 2em;"><br></p>
        <article data-id="2755" data-use="1" data-author="Wxeditor" style="margin: 5px auto;max-width: 100%;font-size: 14px;box-sizing: border-box !important;overflow-wrap: break-word !important;">
          <section style="max-width: 100%;line-height: 25px;text-align: center;box-sizing: border-box !important;overflow-wrap: break-word !important;">
            <section style="margin-bottom: -10px;padding-right: 20px;padding-left: 20px;box-sizing: border-box;max-width: 100%;display: inline-block;border-bottom: 1px solid rgb(127, 127, 127);overflow-wrap: break-word !important;">
              <section style="margin-bottom: -5px;padding-right: 10px;padding-bottom: 5px;padding-left: 10px;box-sizing: border-box;max-width: 100%;border-bottom: 1px solid rgb(127, 127, 127);font-size: 15px;overflow-wrap: break-word !important;">
                <p style="white-space: normal;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;">
                  <strong>
                    <strong style="font-size: 15px;text-align: center;white-space: normal;">微信支付-云闪付</strong>
                  </strong>
                </p>
              </section>
            </section>
            <section style="margin-right: auto;margin-left: auto;box-sizing: border-box;max-width: 100%;width: 11px;height: 11px;border-right: 1px solid rgb(127, 127, 127);border-bottom: 1px solid rgb(127, 127, 127);transform: rotate(45deg);overflow-wrap: break-word !important;"><br></section>
          </section>
        </article>
        <p style="margin-right: 16px;margin-left: 16px;white-space: normal;line-height: 2em;">
          <span style="font-size: 15px;">值得注意的是，微信支付日前亦对外宣布，银联云闪付app和工行、中行、建行、交行、中信、民生银行等13家银行app均支持扫微信收款码付款。</span>
        </p>
        <p style="margin-right: 16px;margin-left: 16px;white-space: normal;line-height: 2em;"><br></p>
        <p style="margin-right: 16px;margin-left: 16px;white-space: normal;line-height: 2em;">
          <span style="font-size: 15px;">实际上在今年的9月30日，腾讯宣布，微信支付已与银联云闪付App正式实现线下条码的互认互扫，用户可于全国省会城市通过云闪付App扫描微信收款码完成支付。</span>
        </p>
        <p style="margin-right: 16px;margin-left: 16px;white-space: normal;line-height: 2em;"><br></p>
        <p style="margin-right: 16px;margin-left: 16px;white-space: normal;line-height: 2em;">
          <span style="font-size: 15px;">11月中旬微信支付已支持在小程序场景内自助开通云闪付功能，这意味着微信支付商户可以在微信支付商户平台开通“云闪付付款到商家“功能；微信支付支持用户通过云闪付付款至已开通的商户。</span>
        </p>
        <p style="margin-right: 16px;margin-left: 16px;white-space: normal;line-height: 2em;"><br></p>
        <p style="margin-right: 16px;margin-left: 16px;white-space: normal;line-height: 2em;">
          <span style="font-size: 15px;">据了解，腾讯与银联在“支付互通”领域开展的合作从去年1月份开始：财付通与银联及建行、中行、交行、平安、中信等多家银行合作，实现手机银行App扫描微信收款码的支付功能，并于福州、宁波、济南等多个城市开启试点；今年8月，云闪付App打通了扫描微信个人收款码可直接支付的能力，在全国省会城市实现了线下条码的互联互通。</span>
        </p>
      </div>
    </div>

    <pc-footer></pc-footer>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.header-wrap {
  // margin-top: -60px;
}
img {
  width: 100%;
  object-fit: cover;
}

.content-wrap {
  padding-top: 50px;
  padding-bottom: 50px;
  width: 900px;
  margin: 0 auto;

  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 38px;
    color: #000000;
    opacity: 0.85;
    text-align: center;
  }
  .time {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: #a8a8a8;
    margin-top: 15px;
    text-align: center;
  }
}
</style>